import React, { useState, useEffect } from 'react';
import { useTheme } from '../../theme/ThemeContext';
import Button from './button';
import Dropdown from './dropdown';

const NeighborSelectorMultiple = ({
    value,
    onChange,
    onSelectMultiple,
    onSelectForEach,
    stepSize = 100,
    maxValue = 1000,
    selectionMethod = 'for combined',
    onSelectionMethodChange
}) => {
    const { theme } = useTheme();

    const currentStepSize = selectionMethod === 'for each' ? 10 : stepSize;
    const currentMaxValue = selectionMethod === 'for each' ? 100 : maxValue;

    useEffect(() => {
        if (value > currentMaxValue) {
            onChange(currentMaxValue);
        } else if (value < currentStepSize) {
            onChange(currentStepSize);
        }
    }, [selectionMethod, value, currentMaxValue, currentStepSize, onChange]);

    const handleInputChange = (e) => {
        const newValue = parseInt(e.target.value, 10);
        if (!isNaN(newValue)) {
            const clampedValue = Math.min(Math.max(newValue, currentStepSize), currentMaxValue);
            onChange(clampedValue);
        }
    };

    const handleSelect = () => {
        if (selectionMethod === 'for combined') {
            onSelectMultiple(value);
        } else {
            onSelectForEach(value);
        }
    };

    const handleMethodChange = (method) => {
        onSelectionMethodChange(method);
        if (method === 'for each') {
            onChange(50);
        } else {
            onChange(500);
        }
    };

    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        padding: '10px 0'
    };

    const buttonWrapperStyle = {
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    };

    const inputStyle = {
        appearance: 'auto',
        border: 'none',
        borderRadius: '8px',
        backgroundColor: theme.colors.overlay || 'rgba(255, 255, 255, 0.1)',
        color: theme.colors.text,
        fontFamily: 'Arial',
        fontSize: '16px',
        fontWeight: '600',
        textAlign: 'center',
        padding: '4px 8px',
        width: '100px',
        minHeight: '32px',
        outline: 'none',
        margin: '0 10px',
        transition: 'all 300ms cubic-bezier(.23, 1, 0.32, 1)',
    };

    const dropdownStyle = {
        margin: '0 10px'
    };

    const buttonContentStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        padding: '0 10px',
        gap: '8px'
    };

    return (
        <div style={containerStyle}>
            <div style={buttonWrapperStyle}>
                <Button onClick={handleSelect}>
                    <div style={buttonContentStyle}>
                        <span>add</span>
                        <input
                            type="number"
                            value={value}
                            onChange={handleInputChange}
                            min={currentStepSize}
                            max={currentMaxValue}
                            step={currentStepSize}
                            style={inputStyle}
                            onClick={(e) => e.stopPropagation()}
                        />
                        <span>nearest neighbors</span>
                        <div style={dropdownStyle} onClick={(e) => e.stopPropagation()}>
                            <Dropdown
                                items={['for combined', 'for each']}
                                onSelect={handleMethodChange}
                                placeholder={selectionMethod}
                                fontSize="14px"
                            />
                        </div>
                    </div>
                </Button>
            </div>
        </div>
    );
};

export default NeighborSelectorMultiple;